export const imageDefaultShare = 'https://d2hz75cbudexsj.cloudfront.net/logo.png';
